// extracted by mini-css-extract-plugin
module.exports = {"link":"_1Snyh","link_active":"_32ZUf"};